import { ECurrency, isoToECurrency } from '@stores/types/*'

import { TPaymentGateway } from '../stores/types/TPaymentGatewayState'

export function extractMinLimit(gw: TPaymentGateway) {
  return (gw.limitTo?.minAmount || gw.limitFrom?.minAmount || '').toString()
}

export function extractMaxLimit(gw: TPaymentGateway) {
  return (gw.limitTo?.maxAmount || gw.limitFrom?.maxAmount || '').toString()
}

export function extractCurrencySymbol(currency?: string) {
  if (!currency) return ''
  const currencyCode = isoToECurrency(currency)
  return currencyCode === ECurrency.RUB ? '₽' : currencyCode ?? ''
}
